const DynamicElectionRoutingService = function ($http, $q, $window) {
    var service = this;

    var success = function (data) {
        return data.data;
    };

    var fault = function (data, status, headers) {
        return $q.reject(headers("exceptionMessage"));
    };

    var complete = function () {};

    service.getTime = function () {
        var url = __baseApiUrl__ + "/participant-web-services/rest/nonauth/service/activity/";
        return $http.get(url).then(success, fault).finally(complete);
    };

    service.getDetails = (id) => {
        var url =
            __baseApiUrl__ +
            `/participant-web-services/rest/accounts/account/${id.individual}/${id.ga}/`;
        return $http.get(url).then(success, fault).finally(complete);
    };

    service.getContactDetails = function () {
        var url =
            __baseApiUrl__ + "/participant-web-services/rest/partialauth/retrieveContactDetails/";
        return $http.get(url).then(success, fault).finally(complete);
    };
};

DynamicElectionRoutingService.$inject = ["$http", "$q", "$window"];
export default DynamicElectionRoutingService;
